import { createUrlParameters, debounce } from '@comeon/utility';

import constants from '../../common/lib/utils/constants.js';
import { fetchJson } from '~/core/ajax-json.js';
import { hydrateShop } from '~/components/shop/ducks/index.js';
import { insertDepositPixel, insertTrackEvent, requestInitialMetaFromStore } from '@comeon/analytics';
import { requestApi } from '~/services/api.js';

const API_BASE_PATH = process.env.API_BASE_PATH || '';

export const onDepositSuccessShop = async (bonusId, dispatch) => {
	const response = fetchJson(`/rest/bonus/${bonusId}`);
	if (response.status === 'SUCCESS') {
		dispatch(hydrateShop());
	}
	return response;
};

export const extractValue = (str, searchStr) => {
	if (!str) return;
	const startOfSection = str.indexOf(searchStr);
	const startOfValue = str.indexOf("': '", startOfSection) + 4;
	const endOffValue = str.indexOf("'", startOfValue);

	return str?.substring(startOfValue, endOffValue);
};

export const getPlayerDetails = data => {
	let playerData;
	try {
		playerData = {
			amount: extractValue(data.pixelTrackingData, 'depositAmount'),
			paymentMethod: extractValue(data.pixelTrackingData, 'paymentMethod'),
			player_email: extractValue(data.pixelTrackingData, 'player_email'),
			player_phone: extractValue(data.pixelTrackingData, 'player_phone'),
			player_address: extractValue(data.pixelTrackingData, 'player_address'),
			player_postcode: extractValue(data.pixelTrackingData, 'player_postcode'),
			player_first_name: extractValue(data.pixelTrackingData, 'player_first_name'),
			player_last_name: extractValue(data.pixelTrackingData, 'player_last_name'),
			player_birthdate: extractValue(data.pixelTrackingData, 'player_birthdate'),
			player_gender: extractValue(data.pixelTrackingData, 'player_gender'),
			player_city: extractValue(data.pixelTrackingData, 'player_city'),
			is_empty: !data.pixelTrackingData
		};
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error('Error parsing pixelTrackingData:', e);
	}
	return playerData;
};

export const trackingDepositFlowCallback = () => {};
export const trackingEventsDepositCallback = (depositSuccessful, err, depositType) => {
	return pixelTrackingResponse => {
		if (pixelTrackingResponse) {
			const amount = extractValue(pixelTrackingResponse, 'depositAmount');
			const event = extractValue(pixelTrackingResponse, 'event');
			const isFirstDeposit = event === 'FirstDepositPixelTracking';
			const paymentMethod = extractValue(pixelTrackingResponse, 'paymentMethod');
			const depositTypeMessage = depositType ? ` - ${depositType}` : '';

			let eventLabel;
			let eventAction;

			if (depositSuccessful) {
				if (isFirstDeposit) {
					eventAction = 'First - Successful';
				} else {
					eventAction = 'Recurring - Successful';
				}

				eventLabel = `${paymentMethod}${depositTypeMessage}`;
			} else {
				if (isFirstDeposit) {
					eventAction = 'First - Failed';
				} else {
					eventAction = 'Recurring - Failed';
				}

				eventLabel = `${paymentMethod} - ${err?.title} - ${err?.message} ${depositTypeMessage}`;
			}

			insertTrackEvent({
				category: 'Deposit',
				action: eventAction,
				label: eventLabel,
				value: amount
			});

			// Request initial meta after deposit
			requestInitialMetaFromStore({ delay: true });
		} else {
			// eslint-disable-next-line
			console.error('Error loading deposit pixel tracking for deposits');
		}
	};
};

export const pendingResultTrackEventCB = (pollData, type) => {
	let timeoutId;
	const data = { ...pollData, deferred: true };
	const defaultServerUrl = '/PaymentFormDataService/getDepositResult?isMobileDevice=true';
	const serverUrl = pollData.paymentFetchResultFlow || pollData.serverUrl || defaultServerUrl;

	const makeCall = async () => {
		try {
			const response = await requestApi(`${API_BASE_PATH}${serverUrl}`, createUrlParameters(data), 'POST', true);
			if (response?.state === constants.SUCCESS) {
				const playerData = getPlayerDetails(response);
				insertDepositPixel(playerData, trackingEventsDepositCallback(true, {}, type));
			}
			clearTimeout(timeoutId);
		} catch (e) {
			console.warn('Pending Result TrackEvent Error!'); // eslint-disable-line
		}
	};

	timeoutId = setTimeout(() => {
		makeCall(true);
	}, 300000);
};

export const logResultTrackEvent = debounce(data => {
	const { paymentMethodName, accHistRef, state, pixelTrackingData } = data ?? {};
	return insertTrackEvent({
		category: 'Deposit',
		action: 'Deposit Result details',
		label: `accHistRef: ${accHistRef} -
		resultState: ${state} -
		paymentMethodName: ${paymentMethodName}  -
		pixelTrackingData: ${pixelTrackingData}`
	});
}, 20000);
